'use client'

import { useMountEffect } from '@react-hookz/web'
import SubscribeForm from '@snowball-tech/common/components/SubscribeForm'
import useTranslations from '@snowball-tech/common/hooks/useTranslations'
import ImageSnowieWateringPlant from '@snowball-tech/common/images/SnowieWateringPlant.svg'
import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'
import { useSearchParams } from 'next/navigation'

import { type ComponentProps, useState } from 'react'

import isEmpty from 'lodash/fp/isEmpty'

import useHomeStore from '@/app/[locale]/(main)/(home)/store'

type Props = {
  smallLabel?: boolean
  submittedTitle?: string | false
  onSubmit?: () => void
} & Pick<ComponentProps<typeof SubscribeForm>, 'label' | 'origin'>
export default function HomeSubscribeForm({
  label = false,
  onSubmit,
  origin,
  smallLabel = false,
  submittedTitle = false,
}: Props) {
  const searchParams = useSearchParams()
  const $t = useTranslations()

  const [startConfettis] = useHomeStore((state) => [state.startConfettis])

  const [isSubmitted, setIsSubmitted] = useState(
    searchParams.get('message') === 'signup-successfull',
  )

  useMountEffect(() => {
    if (isSubmitted) {
      onSubmit?.()
    }
  })

  const handleSubmit = () => {
    setIsSubmitted(true)

    onSubmit?.()
  }

  const handleSubmitted = () => {
    if (!isSubmitted) {
      setIsSubmitted(true)
      onSubmit?.()
    }

    startConfettis()
  }

  const handleFailure = () => {
    setIsSubmitted(false)
  }

  return (
    <div className="flex w-full flex-col gap-1">
      {smallLabel && label !== false && !isEmpty(label) && !isSubmitted && (
        <Typography variant="body-2">{label}</Typography>
      )}

      <SubscribeForm
        buttonLabel={$t('home.hero.subscribe.button.label')}
        buttonPosition="inline"
        iconOnly
        label={smallLabel ? false : label}
        origin={origin}
        submittedContent={
          <div className="text-center">
            <Typography className="text-center" variant="body-2">
              {$t('subscribe.content.submitted.main')}
            </Typography>
          </div>
        }
        submittedImage={ImageSnowieWateringPlant}
        submittedImageWidth={172}
        submittedTitle={submittedTitle}
        onFailure={handleFailure}
        onSubmit={handleSubmit}
        onSubmitted={handleSubmitted}
      />
    </div>
  )
}
